export const filtersMetadata = {
  hour: {
    prefix: 'And in the',
    order: 2,
  },
  day: {
    prefix: 'On a',
    order: 3,
  },
  origin: {
    prefix: 'From',
    order: 1,
  },
  age: {
    suffix: 'years old',
    gender: 2,
  },
  gender: {
    order: 1,
  },
}

export const filtersDefinition: any = {
  arrival: {
    title: 'Movements',
    icon: '/assets/img/icons/negative/movements.svg',
  },
  origin: {
    title: 'Place of origin',
    icon: '/assets/img/icons/negative/places-origin.svg',
  },
  day: {
    title: 'Days',
    icon: '/assets/img/icons/negative/days.svg',
  },
  hour: {
    title: 'Hours',
    icon: '/assets/img/icons/negative/hours.svg',
  },
  target: {
    title: 'Target',
    icon: '/assets/img/icons/negative/target.svg',
    toggle_text: 'Entire population',
    help: 'The entire population will be considered all residents, commuters or tourists, and without making any distinction between gender or age. If you want to refine your query by these basic targets, uncheck this option.',
  },
  gender: {
    title: 'Gender',
  },
  food_delivery_interested: {
    title: 'Food Delivery Interested',
  },
  transport: {
    title: 'Transport',
  },
  online_bet_platform_interested: {
    title: 'Online bet Platforms Interested',
  },
  wealth: {
    title: 'Wealth',
  },
  direction_of_travel: {
    title: 'Direction of travel',
  },
  mode_of_transport: {
    title: 'Mode of transport',
  },
  age: {
    title: 'Age',
    multiple: true,
  },
  visitor_profile: {
    title: 'Type',
    multiple: true,
    help: {
      title: 'Description of types:',
      toggled: true,
    },
  },
  economy: {
    title: 'Economy',
    multiple: true,
    help: {
      title: 'Categorization made by Vodafone data source',
      info: '',
      toggled: false,
    },
  },
  economic_status: {
    title: 'Economy',
    multiple: true,
    help: {
      title: 'Categorization made by Vodafone data source',
      info: '',
      toggled: false,
    },
  },
  nvisits_distribution: {
    title: 'Frequency of visits',
    multiple: true,
    help: {
      title: '',
      info: '',
      toggled: false,
    },
  },
  avg_visit_duration: {
    title: 'Stay time (min)',
    multiple: true,
    help: {
      title: '',
      info: '',
      toggled: false,
    },
  },
  duration: {
    title: 'Duration (min)',
    multiple: true,
    help: {
      title: '',
      info: '',
      toggled: false,
    },
  },
}

export interface IValue {
  info: string
  short_label: string
  label: string
  help: string
  order: number
}

export class BaseFilter {
  id: string
  key_name: string
  title: string
  value: any
  icon: string
  values: Record<string, IValue>
  multiple: boolean
  help: string
  toggleText: string
  hideTarget: boolean
  onlyVisits: boolean
  subfilters: BaseFilter[] = []

  originalData: any
  default: any

  constructor(data: any = {}) {
    this.originalData = data
    const def =
      filtersDefinition[data.kind.replace(' ', '_').toLowerCase()] || {}
    this.id = data.kind || ''
    this.key_name = data.kind || ''
    this.values = {}
    if (data.values instanceof Array) {
      data.values.forEach((value, index) => {
        this.values[value.value] = {
          info: value.info || '',
          label: value.label || '',
          help: value.help || '',
          short_label: value.short_label || value.label,
          order: value.order || index,
        }
      })
    }
    this.value = data.default || Object.keys(this.values)[0] || ''
    this.default = data.default
    this.title = data.title || def.title || ''
    this.icon = data.icon || def.icon || ''
    this.multiple = data.multiple || def.multiple || false
    this.help = data.help || def.help || ''
    this.toggleText = data.toggle_text || def.toggle_text || ''
    this.hideTarget = data.hide_target

    if (data.subfilters instanceof Array) {
      data.subfilters.forEach((sub: any) => {
        this.subfilters.push(new BaseFilter(sub))
      })
    }
  }

  hasSubfilters() {
    return this.subfilters.length > 0
  }

  isSelectedValue(value: string) {
    return this.value instanceof Array
      ? this.value.indexOf(value) > -1
      : this.value === value
  }

  getValues() {
    return Object.keys(this.values)
      .map((value: string) => {
        return {
          value: value,
          order: this.values[value].order || 0,
          info: this.values[value].info,
          label: this.values[value].label,
          help: this.values[value].help,
        }
      })
      .sort((a, b) => a.order - b.order)
  }

  getFirstValue() {
    return this.getValues()[0].value
  }
}
